module.exports = __webpack_public_path__ + "img/d50608f.jpg";